import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { Dayjs } from "dayjs";
import type { FC, KeyboardEvent } from "react";
import { LOCALE } from "../../dayjs";

interface Props {
  readonly label: string | undefined;
  readonly minDate?: Dayjs;
  readonly maxDate?: Dayjs;
  readonly fullWidth?: boolean;
  readonly size?: "small" | "medium";
  readonly width?: number;
  readonly value: Dayjs | null;
  readonly disabled?: boolean;
  readonly onChange: (date: Dayjs | null) => void;
  readonly onKeyPress?: (e: KeyboardEvent) => void;
}

const DatePickerV2: FC<Props> = ({
  label,
  value,
  minDate,
  maxDate,
  fullWidth,
  width,
  size,
  disabled,
  onChange,
  onKeyPress,
}) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={LOCALE}>
    <DatePicker
      label={label}
      minDate={minDate}
      maxDate={maxDate}
      value={value}
      disabled={disabled}
      slotProps={{
        textField: {
          fullWidth,
          size,
          onKeyPress,
          sx: {
            width,
            "&:not(.Mui-disabled):hover .MuiPickersOutlinedInput-notchedOutline": {
              borderColor: "#3557a1",
            },
          },
        },
      }}
      onChange={onChange}
    />
  </LocalizationProvider>
);

export default DatePickerV2;
